/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Alert } from '../../shared/model/alert.model';
import { ConfigService } from '../../../core/services/config.service';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';

@Component({
  selector: 'lms-alert-sub-header',
  templateUrl: './alert-sub-header.component.html',
  styleUrls: ['./alert-sub-header.component.scss']
})
export class AlertSubHeaderComponent {

  @Input() alertLevel: string;
  @Input() deskSignOffAlerts: Array<Alert>;
  @Input() dirSignOffAlerts: Array<Alert>;
  showSignedOff = false;
  configData: any;
  tabLevel: number;

  @Output() signedOffDisplay: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancelSignOff = new EventEmitter();
  @Output() submitAlertOff = new EventEmitter();

  /**
   * Creates an instance of AlertSubHeaderComponent.
   * @param {ConfigService} configService
   * @param {LmsLoaderService} lmsLoaderService
   * @memberof AlertSubHeaderComponent
   */
  constructor(private configService: ConfigService, private lmsLoaderService: LmsLoaderService) {
    this.configData = this.configService.getConfigData();
    this.tabLevel = this.configData.tabIndex.subTabs;
  }

  /**
   * this mehtod is used to emit the submit event
   * for parent component when user clicks on submit button
   * @memberof AlertSubHeaderComponent
   */
  submitOperationForAlerts() {
    this.lmsLoaderService.showLoader();
    this.submitAlertOff.emit('submit');
  }

  /**
   * this mehtod is used to emit the cancel event
   * for parent component when user clicks on cancel button
   * @memberof AlertSubHeaderComponent
   */
  cancelOperationForAlerts() {
    this.lmsLoaderService.showLoader();
    this.cancelSignOff.emit('cancel');
  }

  /**
   * this method is used to emit the event for parent
   * component when user checks the showSignedOff alerts checkbox
   * @param {any} event
   * @memberof AlertSubHeaderComponent
   */
  handleSingedOffAlerts(event) {
    if (event !== undefined) {
      this.lmsLoaderService.showLoader();
      this.showSignedOff = event.checked;
      this.signedOffDisplay.emit(event.checked);
    }
  }

}
